interface NavLinksProps {
  links: {
    dashboard: string;
    tenants: string;
    barcode: string;
    directory: string;
    analytics?: string;
    settings: string;
  };
  tenantScopedLinksOn: boolean;
  className?: string;
  itemClassName?: string;
  onClick?: () => void;
}

/**
 * Shared navigation links component
 * Used by both desktop and mobile navigation
 */
export default function NavLinks({ 
  links, 
  tenantScopedLinksOn, 
  className = '', 
  itemClassName = '',
  onClick 
}: NavLinksProps) {
  const baseLinkClass = "flex items-center gap-1.5 px-2 py-1.5 rounded-md text-neutral-600 hover:text-primary-600 hover:bg-primary-50 transition-all duration-200 font-medium";
  
  return (
    <nav className={className}>
      <a 
        className={`${baseLinkClass} ${itemClassName}`} 
        href={links.dashboard}
        onClick={onClick}
      >
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
        Dashboard
      </a>
      <a 
        className={`${baseLinkClass} ${itemClassName}`} 
        href={links.tenants}
        onClick={onClick}
      >
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
        Tenants
      </a>
      <a 
        className={`${baseLinkClass} ${itemClassName}`} 
        href={links.barcode}
        onClick={onClick}
      >
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
        </svg>
        Barcode
      </a> 
      {links.directory && (
        <a 
          className={`${baseLinkClass} ${itemClassName}`} 
          href={links.directory}
          onClick={onClick}
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          Directory
        </a>
      )}
      {links.analytics && (
        <a 
          className={`${baseLinkClass} ${itemClassName}`} 
          href={links.analytics}
          onClick={onClick}
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
          Analytics
        </a>
      )}
      <a 
        className={`${baseLinkClass} ${itemClassName}`} 
        href={links.settings}
        onClick={onClick}
      >
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
        Settings
      </a>
    </nav>
  );
}
